import screen from './Edit';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/Users/Edit/index.js